import React from 'react';
import BlockChart from '../../BlockChart';
import { useTranslation } from 'react-i18next';
import { useGetPublisherDevicesPerOsQuery } from '../../../api/publisherApiSlice';
import ColumnChart from "../../charts/ColumnChart";

export default function LocationOptInByOs ({publisherId, startDate, endDate}) {
  const defaultData = {"categories":["ios","android"],"series":[{"name":"oui","data":[0,0]},{"name":"non","data":[0,0]}]}
	const { t } = useTranslation();
  const { data = [], isSuccess, isLoading } = useGetPublisherDevicesPerOsQuery({publisherId, startDate, endDate})

  const optIn = (x = {}) => {
    return (x.active_devices == 0 ? 0 : 100 * x.location_authorized_devices/x.active_devices )
  }

  const dataTransform = (data, isSuccess) => {
    if ( isSuccess && data.length > 0 ) {
      const ios = optIn(data.find((d)=>(d.os=="ios")))
      const android = optIn(data.find((d)=>(d.os=="android")))
      return {
        "categories":["ios","android"],
        "series":[
          {"name":"Opt-in","data":[ios, android]}
        ]
      }
    }
    return defaultData
  }
  const chartData = dataTransform(data, isSuccess);
  return (
    <BlockChart title={t("publisher.locationOptInByOs")} isSuccess={isSuccess} isLoading={isLoading}>
      <ColumnChart data={chartData} legendOptions={{show: false}} columnOptions={{yAxis: {max: 100}}}/>
    </BlockChart>
  )
}
